import ButtonEl from './ctas/Button'
const HeroCtaBlock = (props) => {
  return (
    <div
      //   className={`basis-${props.basis ? props.basis : 'auto'} flex justify-${props.textAlignment.flex} max-lg:flex-wrap max-lg:space-y-6 space-x-6 mt-10`}
      className={`basis-${props.basis ? props.basis : 'auto'} flex justify-${props.textAlignment.flex} flex-wrap space-y-6 space-x-6 mt-10`}
    >
      {props.ctaLinkItem.map((ctaLinkItem, i) => (
        <ButtonEl
          key={i}
          link={ctaLinkItem.link}
          theme={ctaLinkItem.linkType.toLowerCase()}
          icon={ctaLinkItem.linkIconClass}
        />
      ))}
    </div>
  )
}

export default HeroCtaBlock
